<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="畅销排行" name="best"></el-tab-pane>
			<el-tab-pane label="滞销排行" name="worst"></el-tab-pane>
			<el-tab-pane label="零销售" name="zero"></el-tab-pane>
		</el-tabs>
		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<el-radio-group v-model="filterDateSlot" size="small">
						<el-radio-button label="1w">一周</el-radio-button>
						<el-radio-button label="2w">两周</el-radio-button>
						<el-radio-button label="1m">一个月</el-radio-button>
						<el-radio-button label="2m">两个月</el-radio-button>
						<el-radio-button label="3m">一个季度</el-radio-button>
						<el-radio-button label="all">全部</el-radio-button>
					</el-radio-group>
				</div>
				<div class="operator-col">
					<brand-input v-model="filterBrand"></brand-input>
				</div>
				<div class="operator-col">
					<classify-input v-model="filterClassify" size="mini"></classify-input>
				</div>
        <div class="operator-col">
          <bool-filter
              size="mini"
              v-model="filterIsStar.value"
              suffix-icon="el-icon-search"
              clearable
              data-model-name="Product_color"
              field="is_star"
              field-name="星标"
          ></bool-filter>
        </div>
				<div class="operator-col" v-if="activeName!='zero'">
					<bool-filter
							size="mini"
							v-model="filterIsAmount.value"
							suffix-icon="el-icon-search"
							clearable
							data-model-name="Product_color"
							field="amount"
							field-name="有库存"
					></bool-filter>
				</div>
        <div class="operator-col">
          <el-button size="mini" type="primary" @click="doSaleExport(editorDataModel,activeName, filterDateSlot, dataFieldShow)">导出</el-button>
        </div>
			</div>
		</div>
		<div class="content-box mt-3" v-if="activeName!='zero'">
			<sum-group-table
				ref="sumGroupTable"
				data-model="Product_color"
				:kv-filter="kvFilter"
				:date-filter="filterHisDate"
				:fields="sumGroupFields"
				:data-fields="dataFields"
				:list-url="'analyse/sales/'+activeName+'/'+filterDateSlot"
				:is-selectable="true"
				:batch-ops="[
                {key:'doHasStarBest',name:'设置星标'},
                {key:'doHasNoStarBest',name:'取消星标'},
            ]"
				@click-batch-op="handleClickBatchOp"
				@getsumdata="getSumData"
			></sum-group-table>
		</div>
		<div class="content-box mt-3" v-if="activeName=='zero'">
			<curd-table
					:isSelectable = true
				ref="sumGroupTable"
				data-model="Product_color"
				:fields="dataFields"
				:kv-filter="kvFilter"
				:date-filter="filterHisDate"
				:list-url="'analyse/sales_zero/'+filterDateSlot"
					:is-selectable="true"
					:batch-ops="[
                {key:'doHasStar',name:'设置星标'},
                {key:'doHasNoStar',name:'取消星标'},
            ]"
					@click-batch-op="handleClickBatchOp"
			>
				<template slot="listOp" slot-scope="scope">
					<el-button type="text" size="mini" @click="handleEditProduct(scope.row._id)"
						>编辑</el-button
					>
					<el-button type="text" size="mini" @click="goCheckTx(scope.row._id)"
						>历史</el-button
					>
				</template>
			</curd-table>
		</div>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import LoadDM from "@/mixins/LoadDM.js";
import SumGroupTable from "@/components/SumGroupTable.vue";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import axios from "axios";
import qs from "qs";

export default {
	components: { SumGroupTable },
	mixins: [LoadDM, CurdPage, Filters, FilterClassify],
	data() {
		return {
			dataModelNames: ["Order", "Order_item"],
			editorDataModel: "Order_item",
			activeName: "best",
			filterDateSlot: "1w",
      filterIsStar: { field: "is_star", value: null },
			filterIsAmount: { field: "amount", value: null },
			sumGroups: [],
			dataBrandFields: [
				{
					name: "name",
				},
			],
      dataFieldShow:[
        "brand",
        "brand_show_id",
        "color_code",
        "name",
        "amount",
        "updated_at",
      ],
			dataFields: [
        {
          name:'is_star',
          params: {
            isRight: true,
          },
          width: "60px",
          render: (info) => {
            let str = info.is_star
            if (str == 0) {
              str = ""
            }else {
              str = "<div style='color: #0e0e0e;font-size: 18px'>★</div>"
            }
            return str;
          },
        },
				{
					name:"thumb_img",
          fieldInfo: {
            oss_style: 'logo',
          },
				},
				{
					name: "brand",
				},
				{
					name: "brand_show_id",
				},
				{
					name: "color_code",
				},
				{
					name: "name",
				},

				{
					name: "amount",
					params: {
						isRight: true,
					},
				},
				{
					name: "updated_at",
					params: {
						isRight: true,
					},
				},
			],
			sumGroupFields: [
				{
					name: "sum_amount",
					title: "件数",
					toFixed: true,
					toFixedLength: 0,
				},
				{
					name: "sum_total_price",
					title: "总价",
					toFixed: true,
					toFixedLength: 2,
				},
				{
					name: "profit_rate",
					title: "毛利率",
					postfix: "%",
					toFixed: true,
					toFixedLength: 2,
				},
			],
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {
		// 事件处理函数
		getSumData(value) {
			console.log('传过来了',value)
			this.sumGroups = value
		},
		handleEditProduct(id) {
			const { href } = this.$router.resolve({
				name: "Config-SPU-Edit",
				params: {
					id: id,
				},
			});
			window.open(href, "_blank");
		},
		goCheckTx(id) {
			const { href } = this.$router.resolve({
				name: "Config-SPU-Tx",
				params: {
					id: id,
				},
			});
			window.open(href, "_blank");
		},
		doHasStar(id){
			this.payIsIncome = true;
			this.payEditorId = id;
			this.payEditorVisible = true;
			console.log(id)
		},
		doHasNoStar(id){
			this.payIsIncome = true;
			this.payEditorId = id;
			this.payEditorVisible = true;
			console.log(id)
		},
		doHasStarBest(id){
			this.payIsIncome = true;
			this.payEditorId = id;
			this.payEditorVisible = true;
			console.log(id)
		},
		doHasNoStarBest(id){
			this.payIsIncome = true;
			this.payEditorId = id;
			this.payEditorVisible = true;
			console.log(id)
		},
		handleBatch_doHasStar(checks)
		{
			this.batchConfirmInfo = {
				count: 0,
				recordIds: [],
			};

			const data = this.$refs["sumGroupTable"].tableData.filter((v, k) => {
				return checks[k];
			});
			console.log('data',data)
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.recordIds.push(v._id);
			});

			axios.post('/api/product/set_star',qs.stringify({
				post:this.batchConfirmInfo.recordIds,
			}))
					.then((json) => {
						console.log(json.data)
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: "设置成功"+json.data.data.info+"条!",
							});
							this.loadings.main = false;
							this.refreshTable("sumGroupTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		},

		handleBatch_doHasNoStar(checks)
		{
			this.batchConfirmInfo = {
				count: 0,
				recordIds: [],
			};

			const data = this.$refs["sumGroupTable"].tableData.filter((v, k) => {
				return checks[k];
			});
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.recordIds.push(v._id);
			});

			console.log(this.batchConfirmInfo.recordIds)

			axios.post('/api/product/set_no_star',qs.stringify({
				post:this.batchConfirmInfo.recordIds,
			}))
					.then((json) => {
						console.log(json.data)
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: "设置成功"+json.data.data.info+"条!",
							});
							this.loadings.main = false;
							this.refreshTable("sumGroupTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		},

		handleBatch_doHasStarBest(checks)
		{
			this.batchConfirmInfo = {
				count: 0,
				recordIds: [],
			};
			const data = this.sumGroups.filter((v, k) => {
				return checks[k];
			});
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.recordIds.push(v._id);
			});

			axios.post('/api/product/set_star',qs.stringify({
				post:this.batchConfirmInfo.recordIds,
			}))
					.then((json) => {
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: "设置成功"+json.data.data.info+"条!",
							});
							this.loadings.main = false;
							this.refreshTable("sumGroupTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		},

		handleBatch_doHasNoStarBest(checks)
		{
			this.batchConfirmInfo = {
				count: 0,
				recordIds: [],
			};
			const data = this.sumGroups.filter((v, k) => {
				return checks[k];
			});
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.recordIds.push(v._id);
			});

			axios.post('/api/product/set_no_star',qs.stringify({
				post:this.batchConfirmInfo.recordIds,
			}))
					.then((json) => {
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: "设置成功"+json.data.data.info+"条!",
							});
							this.loadings.main = false;
							this.refreshTable("sumGroupTable");
						}else {
							this.$message({
								type: "error",
								message: json.data.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		},
	},
	watch: {
		activeName() {
			this.$nextTick(() => {
				this.$refs["sumGroupTable"].refreshData();
			});
		},
    "filterIsStar.value": {
      handler(newVal) {
        let val = this.filterIsStar;
        if (val.value != null && val.value !== "") {
          this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
        } else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
		"filterIsAmount.value": {
			handler(newVal) {
				let val = this.filterIsAmount;
				if (val.value == "1") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", lge:">=", v: 1 });
				} else if(val.value == "0") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", lge:"<", v: 1 });
				}else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			// immediate: true,
		},
		filterDateSlot() {
			this.$nextTick(() => {
				this.$refs["sumGroupTable"].refreshData();
			});
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
